import { render, staticRenderFns } from "./messageLeft.vue?vue&type=template&id=42b6b6fe&scoped=true&"
import script from "./messageLeft.vue?vue&type=script&lang=js&"
export * from "./messageLeft.vue?vue&type=script&lang=js&"
import style0 from "./messageLeft.vue?vue&type=style&index=0&id=42b6b6fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b6b6fe",
  null
  
)

component.options.__file = "messageLeft.vue"
export default component.exports